import { useMediaQuery } from "react-responsive";
import { email_contato } from "./app/utils/Constants";

export default function PoliticaDePrivacidadeApp() {
    const isMediumScreen = useMediaQuery({ query: "(min-width: 1023px)" });

    return (
        <div className="min-vh-100 bg-white">
            <main className="d-flex flex-column gap-32" style={{ padding: isMediumScreen ? 128 : 24, paddingBottom: isMediumScreen ? undefined : 128 }}>
                <section>
                    <h2 className="tt-18 bold color-gray-09">Política de Privacidade - Aplicativo Lumi</h2>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">Introdução e Objetivo</h3>
                    <p className="tt-18 color-gray-09">
                        Bem-vindo(a) ao <span className="fw-semibold">Lumi</span>, uma plataforma desenvolvida e operada pela <span className="fw-semibold">LUMI LTDA</span>. O aplicativo Lumi tem como objetivo cuidar da sua saúde e bem-estar no ambiente de trabalho, auxiliando sua empresa a mapear e prevenir riscos
                        psicossociais, em estrito cumprimento à Norma Regulamentadora nº 1 (NR-1) do Ministério do Trabalho e Emprego.
                    </p>
                    <p className="tt-18 color-gray-09">
                        Sabemos que as informações que você compartilha conosco, especialmente sobre suas emoções, saúde mental e vivências no trabalho, são profundamente pessoais e confidenciais. Esta Política de Privacidade foi criada para explicar, de forma transparente e acessível, como coletamos, usamos,
                        protegemos e quando excluímos seus dados, em total conformidade com a Lei Geral de Proteção de Dados Pessoais (LGPD - Lei nº 13.709/2018).
                    </p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">Definições Importantes</h3>
                    <p className="tt-18 color-gray-09">Para facilitar a compreensão deste documento, adotamos as seguintes definições baseadas na LGPD:</p>
                    <ul className="tt-18 color-gray-09">
                        <li>
                            <span className="fw-semibold">Titular:</span> É você, colaborador que utiliza o aplicativo Lumi.
                        </li>
                        <li>
                            <span className="fw-semibold">Dado Pessoal:</span> Qualquer informação relacionada a você que permita sua identificação (ex: nome, e-mail, matrícula).
                        </li>
                        <li>
                            <span className="fw-semibold">Dado Pessoal Sensível:</span> Dados sobre origem racial ou étnica, convicção religiosa, opinião política, filiação a sindicato, bem como <span className="fw-semibold">dados referentes à saúde</span> (como suas emoções, relatos de estresse, ansiedade e respostas
                            ao diagnóstico psicossocial) ou à vida sexual.
                        </li>
                        <li>
                            <span className="fw-semibold">Tratamento:</span> Qualquer operação realizada com seus dados (coleta, armazenamento, acesso, compartilhamento, exclusão, etc.).
                        </li>
                        <li>
                            <span className="fw-semibold">Controlador:</span> Quem toma as decisões sobre o tratamento dos dados.
                        </li>
                        <li>
                            <span className="fw-semibold">Operador:</span> Quem realiza o tratamento de dados em nome do Controlador.
                        </li>
                        <li>
                            <span className="fw-semibold">Anonimização:</span> Processo irreversível que remove a possibilidade de um dado ser associado a você.
                        </li>
                        <li>
                            <span className="fw-semibold">DPO (Data Protection Officer):</span> O Encarregado de Proteção de Dados, responsável por ser o canal de comunicação entre você, a empresa e a Autoridade Nacional de Proteção de Dados (ANPD).
                        </li>
                    </ul>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">1. Quem Somos (Agentes de Tratamento)</h3>
                    <p className="tt-18 color-gray-09">No contexto do aplicativo Lumi, o tratamento dos seus dados envolve as seguintes partes:</p>
                    <ul className="tt-18 color-gray-09">
                        <li>
                            <span className="fw-semibold">LUMI LTDA (Controladora):</span> Empresa desenvolvedora, provedora e responsável integral pela solução Lumi.
                            <ul>
                                <li>
                                    <span className="fw-semibold">Razão Social:</span> LUMI LTDA
                                </li>
                                <li>
                                    <span className="fw-semibold">CNPJ:</span> 65.624.349/0001-40
                                </li>
                                <li>
                                    <span className="fw-semibold">Natureza Jurídica:</span> Sociedade Empresária Limitada (EPP)
                                </li>
                                <li>
                                    <span className="fw-semibold">Endereço:</span> Avenida Senador Tarso Dutra, nº 605, Sala 1501 B, Bairro Petrópolis, Porto Alegre/RS, CEP 90.690-140
                                </li>
                                <li>
                                    <span className="fw-semibold">Telefone:</span> (51) 3029-4987
                                </li>
                                <li>
                                    <span className="fw-semibold">E-mail:</span> {email_contato}
                                </li>
                            </ul>
                        </li>
                        <li>
                            <span className="fw-semibold">Sua Empresa Empregadora (Co-controladora):</span> A empresa onde você trabalha, que contratou o Lumi. É ela quem, por meio de seus gestores autorizados, realiza a gestão do seu cadastro no Painel do Cliente, incluindo a criação e a exclusão da conta no
                            aplicativo.{" "}
                            <em>
                                Importante: Apesar de gerenciar o cadastro, a sua empresa terá acesso <span className="fw-semibold">apenas a relatórios agregados e anonimizados</span>, nunca aos seus registros individuais de emoções, conversas com a Luz ou respostas individualizadas ao diagnóstico psicossocial.
                            </em>
                        </li>
                    </ul>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">2. Dados que Coletamos</h3>
                    <p className="tt-18 color-gray-09">Para que o Lumi funcione adequadamente, coletamos diferentes categorias de dados:</p>
                    <table className="table table-bordered tt-18 color-gray-09">
                        <thead>
                            <tr>
                                <th>Categoria</th>
                                <th>Dados Coletados</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <span className="fw-semibold">Dados Cadastrais</span>
                                </td>
                                <td>Nome completo, e-mail corporativo, cargo, departamento/setor.</td>
                            </tr>
                            <tr>
                                <td>
                                    <span className="fw-semibold">Dados de Uso do App</span>
                                </td>
                                <td>Logs de acesso, identificador do dispositivo (device_id), versão do sistema operacional, data e hora de acesso.</td>
                            </tr>
                            <tr>
                                <td>
                                    <span className="fw-semibold">DADOS PESSOAIS SENSÍVEIS (Saúde e Bem-estar)</span>
                                </td>
                                <td>
                                    <ul>
                                        <li>
                                            <span className="fw-semibold">Registros emocionais diários:</span> sentimentos registrados (alegria, amor, tristeza, raiva, cansaço, calma, surpresa, indiferença, medo/ansiedade).
                                        </li>
                                        <li>
                                            <span className="fw-semibold">Contexto emocional:</span> descrições das causas da emoção (trabalho, relacionamentos, saúde, família, finanças, autocuidado, espiritualidade, etc.).
                                        </li>
                                        <li>
                                            <span className="fw-semibold">Interações com a IA:</span> histórico de conversas em chat com a assistente virtual "Luz".
                                        </li>
                                        <li>
                                            <span className="fw-semibold">Diagnóstico Psicossocial (NR-1):</span> respostas a questionários (cerca de 35 perguntas) abordando Demanda, Controle, Apoio, Relacionamentos, Função e Mudanças, podendo incluir tópicos delicados como percepção de assédio moral, burnout, estresse
                                            e ansiedade.
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">3. Como Coletamos seus Dados</h3>
                    <p className="tt-18 color-gray-09">
                        Os dados são coletados <span className="fw-semibold">diretamente de você</span>, de forma ativa, quando você interage com o aplicativo Lumi (por exemplo, ao registrar uma emoção, conversar com a Luz ou responder ao Diagnóstico Psicossocial). Seus dados cadastrais básicos são fornecidos
                        previamente pela sua empresa empregadora para a criação da sua conta.
                    </p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">4. Finalidades e Bases Legais</h3>
                    <p className="tt-18 color-gray-09">Em conformidade com os Artigos 7º e 11º da LGPD, tratamos seus dados apenas para finalidades específicas e com amparo legal adequado:</p>
                    <table className="table table-bordered tt-18 color-gray-09">
                        <thead>
                            <tr>
                                <th>Dados Tratados</th>
                                <th>Finalidade</th>
                                <th>Base Legal (LGPD)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Dados Cadastrais</td>
                                <td>Criação e autenticação de conta; suporte técnico.</td>
                                <td>Execução de Contrato (Art. 7, V)</td>
                            </tr>
                            <tr>
                                <td>Respostas ao Diagnóstico Psicossocial (NR1)</td>
                                <td>Mapeamento de riscos psicossociais e elaboração do Programa de Gerenciamento de Riscos (PGR) da sua empresa.</td>
                                <td>Cumprimento de Obrigação Legal/Regulatória (Art. 11, II, a') - NR-1 do MTE</td>
                            </tr>
                            <tr>
                                <td>Registros Emocionais e Chat com a "Luz"</td>
                                <td>Fornecer suporte emocional primário, acompanhamento de bem-estar individual e geração de relatórios de saúde populacional anonimizados.</td>
                                <td>Consentimento do Titular (Art. 11, I) e Tutela da Saúde (Art. 11, II, 'f')</td>
                            </tr>
                            <tr>
                                <td>Dados de Uso (Logs)</td>
                                <td>Garantir a segurança da informação, prevenir fraudes e auditar o sistema.</td>
                                <td>Cumprimento de Obrigação Legal (Marco Civil da Internet) e Legítimo Interesse (Art. 7, IX)</td>
                            </tr>
                        </tbody>
                    </table>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">5. Com Quem Compartilhamos seus Dados</h3>
                    <p className="tt-18 color-gray-09">O compartilhamento de dados obedece a regras rígidas de segurança e privacidade:</p>
                    <ul className="tt-18 color-gray-09">
                        <li>
                            <span className="fw-semibold">Com a sua Empresa Empregadora:</span> A sua empresa recebe <span className="fw-semibold">APENAS relatórios estatísticos, agregados e anonimizados</span> (ex: "40% do setor de vendas relatou sobrecarga"). <span className="fw-semibold">NUNCA</span> compartilhamos
                            seus registros individuais de emoções, suas conversas com a IA "Luz" ou suas respostas individuais ao diagnóstico psicossocial com seu empregador ou gestores diretos.
                        </li>
                        <li>
                            <span className="fw-semibold">Com Operadores Técnicos:</span> Compartilhamos dados estritamente necessários com provedores de infraestrutura em nuvem e serviços auxiliares contratados pela LUMI LTDA, sob contratos rigorosos de confidencialidade e cláusulas específicas de proteção de dados.
                        </li>
                        <li>
                            <span className="fw-semibold">Autoridades Públicas:</span> Apenas mediante ordem judicial ou obrigação legal (ex: auditorias do Ministério do Trabalho).
                        </li>
                    </ul>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">6. Retenção de Dados (Prazos)</h3>
                    <p className="tt-18 color-gray-09">Não manteremos seus dados para sempre. Eles são armazenados apenas pelo tempo necessário para cumprir as finalidades descritas, respeitando os seguintes prazos:</p>
                    <table className="table table-bordered tt-18 color-gray-09">
                        <thead>
                            <tr>
                                <th>Tipo de Dado</th>
                                <th>Prazo de Retenção</th>
                                <th>Justificativa Legal / Ação após o prazo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Dados Cadastrais</td>
                                <td>Enquanto durar seu vínculo empregatício + 5 anos após o encerramento.</td>
                                <td>Prescrição trabalhista. Após o prazo, são excluídos irreversivelmente.</td>
                            </tr>
                            <tr>
                                <td>Registros emocionais individuais</td>
                                <td>24 meses.</td>
                                <td>Garantia de histórico de curto prazo. Após o prazo, são excluídos ou totalmente anonimizados.</td>
                            </tr>
                            <tr>
                                <td>Conversas com a "Luz" (Chat)</td>
                                <td>12 meses.</td>
                                <td>Privacidade do usuário. Após o prazo, os textos são excluídos ou anonimizados.</td>
                            </tr>
                            <tr>
                                <td>Respostas ao Diagnóstico Psicossocial</td>
                                <td>20 anos (para dados que compõem o GRO/PGR) ou pelo período do vínculo + 5 anos.</td>
                                <td>Obrigação Legal da NR-1 (item 1.5.7.3.3.1). Os dados são mantidos de forma segura e pseudonimizada.</td>
                            </tr>
                            <tr>
                                <td>Dados Agregados e Anonimizados</td>
                                <td>Prazo indeterminado.</td>
                                <td>LGPD Art. 12 (Dados anonimizados não são considerados dados pessoais para fins da lei).</td>
                            </tr>
                            <tr>
                                <td>Logs de Acesso</td>
                                <td>Mínimo de 6 meses.</td>
                                <td>Obrigação Legal (Art. 15 do Marco Civil da Internet - Lei 12.965/2014).</td>
                            </tr>
                        </tbody>
                    </table>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">7. Seus Direitos como Titular</h3>
                    <p className="tt-18 color-gray-09">De acordo com o Artigo 18 da LGPD, você possui os seguintes direitos em relação aos seus dados pessoais:</p>
                    <ol className="tt-18 color-gray-09">
                        <li>
                            <span className="fw-semibold">Confirmação:</span> Saber se realizamos o tratamento de seus dados.
                        </li>
                        <li>
                            <span className="fw-semibold">Acesso:</span> Solicitar uma cópia dos dados que possuímos sobre você.
                        </li>
                        <li>
                            <span className="fw-semibold">Correção:</span> Solicitar a correção de dados incompletos, inexatos ou desatualizados.
                        </li>
                        <li>
                            <span className="fw-semibold">Anonimização, bloqueio ou eliminação:</span> Para dados desnecessários, excessivos ou tratados em desconformidade com a LGPD.
                        </li>
                        <li>
                            <span className="fw-semibold">Portabilidade:</span> Solicitar a transferência dos seus dados a outro fornecedor, mediante requisição expressa.
                        </li>
                        <li>
                            <span className="fw-semibold">Eliminação:</span> Solicitar a exclusão dos dados tratados com base no seu consentimento (sujeito às exceções legais).{" "}
                            <em>Importante: a execução da exclusão do cadastro no Lumi é realizada pelo gestor da sua empresa via Painel do Cliente — veja o item 10 para entender o fluxo completo de solicitação.</em>
                        </li>
                        <li>
                            <span className="fw-semibold">Informação sobre compartilhamento:</span> Saber com quais entidades públicas ou privadas compartilhamos seus dados.
                        </li>
                    </ol>
                    <p className="tt-18 color-gray-09">
                        <span className="fw-semibold">Informação sobre consequências da negativa:</span> Saber o que acontece caso você não forneça o consentimento para certas funções do app.
                    </p>
                    <p className="tt-18 color-gray-09">
                        <span className="fw-semibold">Revogação do consentimento:</span> Retirar a permissão que você nos deu anteriormente, a qualquer momento.
                    </p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">8. Como Excluir seus Dados</h3>
                    <p className="tt-18 color-gray-09">
                        Garantimos a você o direito de solicitar a exclusão dos seus dados. No entanto, como o Lumi é uma ferramenta corporativa contratada pela sua empresa empregadora para o cumprimento da NR-1, a gestão do ciclo de vida do cadastro (criação e exclusão) é realizada pela sua empresa, e não pelo próprio
                        colaborador dentro do aplicativo.
                    </p>

                    <h4 className="tt-18 bold color-gray-09">9. Exclusão do Cadastro pelo Gestor (Painel do Cliente)</h4>
                    <p className="tt-18 color-gray-09">A exclusão do cadastro de um colaborador no Lumi é realizada exclusivamente pelo gestor autorizado da empresa empregadora, através do Painel do Cliente, tipicamente nas seguintes situações:</p>
                    <ul className="tt-18 color-gray-09">
                        <li>Encerramento do vínculo empregatício (desligamento, demissão, aposentadoria).</li>
                        <li>Atendimento a uma solicitação formal de exclusão feita pelo colaborador (conforme item 10.2).</li>
                        <li>Correção de cadastros duplicados ou incorretos.</li>
                    </ul>
                    <p className="tt-18 color-gray-09">
                        Após a ação do gestor, o processo de exclusão é executado pela LUMI LTDA em até <span className="fw-semibold">30 dias</span>, respeitadas as exceções legais descritas no item 10.4.
                    </p>

                    <h4 className="tt-18 bold color-gray-09">10. Prazos e Fluxo da Solicitação</h4>
                    <ul className="tt-18 color-gray-09">
                        <li>
                            <span className="fw-semibold">Confirmação de recebimento:</span> até 2 dias úteis após o registro da solicitação (via app ou DPO).
                        </li>
                        <li>
                            <span className="fw-semibold">Resposta formal ao titular:</span> até <span className="fw-semibold">15 dias</span> (Art. 19 da LGPD), informando as providências tomadas, quais dados foram excluídos e quais (se houver) precisam ser mantidos por obrigação legal.
                        </li>
                        <li>
                            <span className="fw-semibold">Efetivação da exclusão:</span> até 30 dias após a validação da solicitação, contados a partir da execução pelo gestor ou pelo DPO.
                        </li>
                    </ul>
                    <p className="tt-18 color-gray-09">
                        Se, por qualquer motivo, o gestor da sua empresa não executar a exclusão no prazo adequado, a LUMI LTDA, como controladora, poderá realizar a exclusão diretamente, mediante validação do DPO, para assegurar o cumprimento da LGPD. Você será informado caso isso ocorra.
                    </p>

                    <h4 className="tt-18 bold color-gray-09">11. O que acontece após a exclusão?</h4>
                    <dl className="tt-18 color-gray-09">
                        <dt className="fw-semibold">Acesso ao app:</dt>
                        <dd>Encerrado imediatamente após a exclusão do cadastro pelo gestor no Painel do Cliente.</dd>
                        <dt className="fw-semibold">Dados individuais:</dt>
                        <dd>Removidos das bases ativas em até 30 dias.</dd>
                        <dt className="fw-semibold">Backups (cópias de segurança):</dt>
                        <dd>Purgados automaticamente no ciclo de rotatividade, em até 90 dias.</dd>
                        <dt className="fw-semibold">Dados Agregados:</dt>
                        <dd>Informações já integradas a relatórios estatísticos da empresa (onde sua identidade foi completamente desvinculada) permanecem mantidas, pois não constituem mais dados pessoais.</dd>
                    </dl>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">12. Segurança da Informação</h3>
                    <p className="tt-18 color-gray-09">Levamos a segurança dos seus dados a sério e implementamos medidas técnicas e administrativas rigorosas:</p>
                    <ul className="tt-18 color-gray-09">
                        <li>
                            <span className="fw-semibold">Criptografia:</span> Seus dados são criptografados em trânsito (utilizando protocolo TLS 1.3) e em repouso nos nossos servidores (padrão AES-256).
                        </li>
                        <li>
                            <span className="fw-semibold">Controle de Acesso:</span> Implementamos segregação de perfis. Gestores da sua empresa empregadora não possuem credenciais de acesso aos bancos de dados de saúde individual do Lumi.
                        </li>
                        <li>
                            <span className="fw-semibold">Pseudonimização:</span> Identificadores diretos são separados dos dados de saúde sempre que possível no banco de dados.
                        </li>
                        <li>
                            <span className="fw-semibold">Monitoramento:</span> Nossos sistemas contam com monitoramento contínuo para detecção de anomalias e tentativas de invasão.
                        </li>
                        <li>
                            <span className="fw-semibold">Resposta a Incidentes:</span> Em caso de qualquer incidente de segurança que possa acarretar risco relevante, comunicaremos a você e à ANPD (Autoridade Nacional de Proteção de Dados) no prazo máximo de 2 dias úteis.
                        </li>
                    </ul>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">13. Transferência Internacional de Dados</h3>
                    <p className="tt-18 color-gray-09">
                        Para hospedar o aplicativo Lumi e garantir alta disponibilidade, podemos utilizar servidores de provedores de nuvem (Cloud Computing) que possuam datacenters localizados fora do Brasil (como Estados Unidos ou Europa). Em obediência ao Artigo 33 da LGPD, garantimos que essas transferências
                        ocorrem apenas para países com grau de proteção de dados adequado ou mediante contratos que exigem o mesmo nível de segurança exigido pela legislação brasileira.
                    </p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">14. Cookies e Tecnologias Similares</h3>
                    <p className="tt-18 color-gray-09">
                        O aplicativo Lumi pode utilizar tecnologias locais de armazenamento (como <em>tokens</em> de sessão) no seu smartphone exclusivamente para manter você logado de forma segura e lembrar de suas preferências de interface (ex: modo escuro). Não utilizamos cookies de rastreamento publicitário ou
                        ferramentas de terceiros focadas em marketing comportamental dentro do app.
                    </p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">15. Tratamento de Dados de Menores</h3>
                    <p className="tt-18 color-gray-09">
                        O aplicativo Lumi é uma ferramenta corporativa voltada para a saúde e segurança do trabalho, sendo destinado <span className="fw-semibold">exclusivamente a colaboradores maiores de 18 (dezoito) anos</span>, ou a jovens aprendizes a partir de 14 anos sob base contratual legal. O aplicativo não
                        coleta intencionalmente dados de crianças (menores de 12 anos).
                    </p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">16. Alterações nesta Política</h3>
                    <p className="tt-18 color-gray-09">
                        Estamos sempre melhorando o Lumi e, por isso, esta Política de Privacidade pode passar por atualizações. Caso realizemos mudanças significativas sobre como tratamos seus dados sensíveis, você receberá uma notificação em destaque no aplicativo com{" "}
                        <span className="fw-semibold">pelo menos 30 dias de antecedência</span> da entrada em vigor da nova versão, solicitando, se necessário, a renovação do seu consentimento.
                    </p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">17. Contato do Encarregado de Dados (DPO)</h3>
                    <p className="tt-18 color-gray-09">Se você tiver qualquer dúvida, preocupação ou quiser exercer seus direitos previstos na LGPD, entre em contato diretamente com o nosso Encarregado de Proteção de Dados:</p>
                    <ul className="tt-18 color-gray-09">
                        <li>
                            <span className="fw-semibold">Encarregado:</span> Encarregado de Proteção de Dados da LUMI LTDA
                        </li>
                        <li>
                            <span className="fw-semibold">E-mail:</span> {email_contato}
                        </li>
                        <li>
                            <span className="fw-semibold">Endereço para correspondência:</span> Avenida Senador Tarso Dutra, nº 605, Sala 1501 B, Bairro Petrópolis, Porto Alegre/RS, CEP 90.690-140
                        </li>
                        <li>
                            <span className="fw-semibold">Telefone:</span> (51) 3029-4987
                        </li>
                    </ul>
                    <p className="tt-18 color-gray-09">Você também tem o direito de peticionar em relação aos seus dados perante a Autoridade Nacional de Proteção de Dados (ANPD) através dos canais oficiais do governo.</p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">18. Disposições Finais e Foro</h3>
                    <p className="tt-18 color-gray-09">
                        Esta Política é regida pelas leis da República Federativa do Brasil, em especial a LGPD e normativas do MTE. Fica eleito o foro da Comarca de Porto Alegre/RS, sede da LUMI LTDA, para dirimir quaisquer dúvidas decorrentes deste documento, com renúncia expressa a qualquer outro, por mais
                        privilegiado que seja.
                    </p>
                    <p className="tt-18 color-gray-09">Documento elaborado em conformidade com a LGPD (Lei 13.709/2018) e NR-1 do Ministério do Trabalho e Emprego.</p>
                </section>
            </main>
        </div>
    );
}
